import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
const LineSeparatorRootWrapperStyled = styled.div `
  ${({ styles }) => getStyles(styles?.container)}
`;
export { LineSeparatorRootWrapperStyled };
//# sourceMappingURL=line-separator.component.styled.js.map